import { http, HttpResponse } from 'msw';
import { encashMocks } from '../mocks';

export const encashHandler = http.get('*/encash?*', () =>
  HttpResponse.json(encashMocks.encashes)
);

export const encashSumHandler = http.get('*/encash/sum?*', () =>
  HttpResponse.json(encashMocks.sum)
);
